import styled from '@emotion/styled/macro';

export const Wrapper = styled.div`
    border-radius: 8px;
    box-shadow: 0 2px 16px rgba(0, 0, 0, 0.15);
    max-width: 343px;
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    overflow: auto;
`;

export const RunnerWrapper = styled.div`
    width: calc(100% - 32px);
    padding: 0 16px;
    height: 73px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background: #ffffff;
`;

export const SkyBetOddsWrapper = styled.a`
    width: calc(100% - 32px);
    padding: 0 16px;
    background-color: ${props => props.theme.colours.skybet.blue};
    color: white;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-family: ${props => props.theme.fonts.medium};
    text-decoration: none;

    @media (max-width: 340px) {
        font-size: 12px;
    }
`;

export const LeftBody = styled.div`
    display: flex;
    justify-content: flex-start;
    margin-right: 8px;
`;

export const RightBody = styled.div`
    text-align: left;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 34px;
`;

export const ClothNumber = styled.div`
    color: ${props => props.theme.colours.textGreen};
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    font-size: ${props => props.theme.fontSize.large};
    margin-right: 8px;
`;

export const HorseName = styled.span`
    text-align: left;
    color: ${props => props.theme.colours.textGreen};
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    font-size: ${props => props.theme.fontSize.normal};
    font-weight: 500;
`;

export const Divider = styled.span`
    color: ${props => props.theme.colours.textGreen};
    font-family: ${props => props.theme.fonts.gtWalsheimProMedium};
    font-size: ${props => props.theme.fontSize.xsmall};
`;

export const TrainerAndJockey = styled.span`
    color: ${props => props.theme.colours.textDark};
    font: ${props => props.theme.fonts.gtWalsheimProMedium};
    font-size: ${props => props.theme.fontSize.xsmall};
`;

export const Silk = styled.img`
    width: 42px;
`;

export const SkyBetLogo = styled.img`
    width: 54px;
    margin-left: 4px;
`;

export const RightCaret = styled.img`
    width: 8px;
    margin-left: auto;
`;
